import { HttpClient } from '@/cowboy/http/HttpClient'
import { JsonSerializable } from '@/util/object/JsonSerializable'

export class HttpInjector {
  static get $http () {
    return HttpClient.http
  }

  /**
   * Object containing requestCode and urlVersion data
   * @return {RequestCodeVersion}
   */
  static get codeVersion () {
    return HttpClient.codeVersion
  }

  /**
   * Cast Return Data to provided type that is a prototype of JsonSerializable
   * @template T
   * @param {Object} responseData
   * @param {Class<T>} TypeClass
   * @return {T|Array<T>}
   */
  static cast (responseData, TypeClass) {
    if (responseData instanceof Error) {
      throw responseData
    } else if (TypeClass instanceof Function &&
      TypeClass.prototype instanceof Object &&
      JsonSerializable.isPrototypeOf(TypeClass)) {
      if (Array.isArray(responseData)) {
        return responseData.map(item => TypeClass.fromJSON(item))
      }
      return TypeClass.fromJSON(responseData)
    }
    throw new Error('TypeClass is not a prototype of JsonSerializable')
  }
}
